import Bar from "../states/Bar";

// Matches BuyerNeedCard line for line so the list doesn't reflow when the real
// rows land: id/agent, city/price, then the three spec figures.
const RowSkeleton = () => (
  <div className="border-b border-gray-100 px-4 py-3 last:border-b-0">
    <div className="mb-1 flex h-5 items-center justify-between">
      <Bar w={120} h={12} />
      <Bar w={140} h={12} />
    </div>
    <div className="mb-0.5 flex h-5 items-center justify-between">
      <Bar w={160} h={11} />
      <Bar w={180} h={11} />
    </div>
    <div className="flex h-4 items-center gap-6">
      <Bar w={54} h={10} />
      <Bar w={54} h={10} />
      <Bar w={110} h={10} />
    </div>
  </div>
);

const BuyerNeedsSkeleton = ({ rows = 6 }) => (
  <div className="overflow-hidden rounded-lg border border-light_gray bg-white shadow-card">
    {Array.from({ length: rows }, (_, i) => (
      <RowSkeleton key={i} />
    ))}
  </div>
);

export default BuyerNeedsSkeleton;
